import React from 'react';
import { imageScaleUrl } from '../../../helpers/imageScales';
import './dishshowcase.scss';

interface DishData {
  name: string;
  desc: string;
  imageUrl: string | null;
  imageValue: any;
  fieldId: string;
}

const View = ({ data, isEditMode, imageSlot }: any) => {
  const eyebrow = data.eyebrow || 'Quelques plats';
  const heading = data.heading || 'Ce qui sort de la cuisine.';
  const description =
    data.description ||
    'Trois plats parmi ceux que vous trouverez régulièrement à la carte. La carte complète tient à jour les changements de saison.';

  const getDishImageUrl = (imageField: any): string | null => {
    if (imageField && Array.isArray(imageField) && imageField.length > 0) {
      return imageScaleUrl(imageField[0], 'large');
    }
    return null;
  };

  const dishes: DishData[] = [
    {
      name: data.dish1_name || '',
      desc: data.dish1_desc || '',
      imageUrl: getDishImageUrl(data.dish1_image),
      imageValue: data.dish1_image,
      fieldId: 'dish1_image',
    },
    {
      name: data.dish2_name || '',
      desc: data.dish2_desc || '',
      imageUrl: getDishImageUrl(data.dish2_image),
      imageValue: data.dish2_image,
      fieldId: 'dish2_image',
    },
    {
      name: data.dish3_name || '',
      desc: data.dish3_desc || '',
      imageUrl: getDishImageUrl(data.dish3_image),
      imageValue: data.dish3_image,
      fieldId: 'dish3_image',
    },
  ];

  return (
    <section className="dishes">
      <div className="shell">
        <div className="dishes-head">
          <div>
            <p className="eyebrow">{eyebrow}</p>
            <h2>{heading}</h2>
          </div>
          {description && <p>{description}</p>}
        </div>
        <div className="dish-grid">
          {dishes.map((dish, i) => {
            const defaultImageElement = dish.imageUrl ? (
              <img src={dish.imageUrl} alt={dish.name} loading="lazy" />
            ) : null;
            const slotted = imageSlot?.({
              fieldId: dish.fieldId,
              index: i,
              value: dish.imageValue,
              element: defaultImageElement,
            });
            return (
              <article className="dish" key={i}>
                <div className="dish-img">
                  {slotted ??
                    defaultImageElement ??
                    (isEditMode && (
                      <span
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          height: '100%',
                          color: 'var(--brume)',
                          fontSize: '14px',
                        }}
                      >
                        Image plat {i + 1}
                      </span>
                    ))}
                </div>
                {dish.name && <h3 className="dish-name">{dish.name}</h3>}
                {dish.desc && <p className="dish-desc">{dish.desc}</p>}
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default View;
